import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'app-import-code-div',
  templateUrl: './import-code-div.component.html',
  styleUrls: ['./import-code-div.component.css']
})
export class ImportCodeDivComponent implements OnInit {

  @Input() options;
  @Input() config;
  @Output() changeAction = new EventEmitter();
  @Output() clickAction = new EventEmitter();

  constructor() { }

  ngOnInit() {
  
  }

  changeCategory(evt) {
    this.changeAction.emit(evt);

  }

  saveCode(data) {
    this.clickAction.emit(data);

  }



}
